<template>
  <li class="row-scroll-item" :style="customStyle">
    <slot></slot>
  </li>
</template>

<script>
  export default {
    name: 'row-scroll-item',
    props: {
      width: {
        type: String,
        default: '105px'
      },
    },
    mounted() {
      this.$parent && this.$parent.rowScrollItemCreated(this);
    },
    computed: {
      customStyle() {
        return [
          {width: this.width},
          {'min-width': this.width}
        ]
      },
    },
    destroyed() {
      this.$parent && this.$parent.rowScrollItemDestroyed(this);
    }
  };
</script>
<style lang="less" scoped>
.row-scroll-item{
  cursor: pointer;
  display: block;
  float: left;
  width: 105px;
  &::before,&::after {
    content: "";
    display: table;
  }
  &::after {
    clear: both;
  }
}
</style>
